import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// redux imports
import { setDeviceData } from "../../../redux/features/devices/devices";

// components imports
import CardContainer from "../../_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TextWithBank from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import BorderAddComponent from "../../_utils/BorderAddComponent";
import accountNameStandardised from "../../../utils/accountNamestandardised";

const MyDeviceCard = ({ data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const deviceData = data;

  const loggedInDevice = deviceData?.find(
    (device) => device.logged_in_flag === "Y",
  );

  return (
    <div className="standard-setting-card-alignment gap-y-gap-md gap-x-gap-sm my-margin-md px-padding-sm">
      {deviceData?.map((device) => (
        <>
          <BorderAddComponent
            showBorder={device?.logged_in_flag === "Y" ? true : false}
            borderColor={"emphasis"}
            shouldAnimate={false}
          >
            <CardContainer
              onClickHandler={() => {
                let data = {
                  loggedInUser: loggedInDevice,
                  deviceId: device?.id,
                  devices: deviceData,
                };

                dispatch(setDeviceData(data));
                navigate(
                  `/settings/devices_view_all/devices_detail_page/${device.id}`,
                );
              }}
            >
              <card-body>
                <div className="justify-between flex flex-col gap-gap-sm">
                  <TextWithIcon
                    type={"text"}
                    fontWeight={"normal"}
                    text={
                      device.platform?.toLowerCase() === "web" ||
                      device.platform?.toLowerCase() === "pwa"
                        ? device.browser_name
                        : device.model
                    }
                    subText={
                      device?.platform?.toLowerCase() === "web"
                        ? "Browser name"
                        : "Model"
                    }
                    textColor={"var(--text-primary)"}
                  />
                  <TextWithIcon
                    type={"text"}
                    fontWeight={"normal"}
                    text={accountNameStandardised(device?.platform)}
                    subText={"Platform"}
                    textColor={"var(--text-primary)"}
                  />
                </div>

                <TextWithBank
                  text={device.os_version}
                  subText={"Operating system"}
                  type={"Text"}
                  src={
                    device.platform === "android"
                      ? "https://q2pay.in/new_assets/common/timeline_icons/android.svg"
                      : device.platform === "iOS"
                        ? "https://q2pay.in/new_assets/common/timeline_icons/mac_os.svg"
                        : device.browser_name === "Google Chrome"
                          ? "https://q2pay.in/new_assets/common/timeline_icons/chrome.svg"
                          : device.browser_name === "Apple Safari"
                            ? "https://q2pay.in/new_assets/common/timeline_icons/safari.svg"
                            : device.browser_name === "Mozilla Firefox"
                              ? "https://q2pay.in/new_assets/common/timeline_icons/mozilla_firefox.svg"
                              : device.browser_name === "Microsoft Edge"
                                ? "https://q2pay.in/new_assets/common/timeline_icons/microsoft_edge.svg"
                                : device.browser_name ===
                                    "Microsoft Internet Explorer"
                                  ? "https://q2pay.in/new_assets/common/timeline_icons/explorer.svg"
                                  : "https://q2pay.in/new_assets/common/timeline_icons/default_browser.svg"
                  }
                />
              </card-body>
            </CardContainer>
          </BorderAddComponent>
        </>
      ))}
    </div>
  );
};

export default MyDeviceCard;
